module.exports = __webpack_public_path__ + "img/logo.1fd62c7b.png";